export const generateReactKey = () =>
  Math.random()
    .toString(36)
    .substr(2, 5);
